"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_idea__or__innovation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a8f59874-2d16-494b-9cce-5fa1a3221c08",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "idea-or-innovation-mid"), /*#__PURE__*/React.createElement("path", {
    d: "M126,130c0-13.38,10.05-25,10.05-25a81.73,81.73,0,0,0,6.42-9.21A50.1,50.1,0,0,0,149.75,70h0s0-.09,0-.14c0-.83,0-1.65-.07-2.47v-.15C148.31,41.88,127.53,19,97.88,18.05q-.94,0-1.88,0t-1.88,0C64.47,19,43.69,41.88,42.32,67.24v.15c0,.82-.07,1.64-.07,2.47,0,0,0,.09,0,.14h0a50.1,50.1,0,0,0,7.28,25.78A81.73,81.73,0,0,0,55.95,105S66,116.62,66,130h0a4,4,0,0,0,4,4h52a4,4,0,0,0,4-4Z",
    fill: "none",
    stroke: "#676767",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,134v19.66A12.34,12.34,0,0,1,109.66,166H82.34A12.34,12.34,0,0,1,70,153.66V134",
    fill: "none",
    stroke: "#676767",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.82,170.05",
    fill: "none",
    stroke: "#676767",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,166v4a4,4,0,0,1-4,4H92a4,4,0,0,1-4-4v-4",
    fill: "none",
    stroke: "#676767",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "86 134 86 118 106 118 106 134",
    fill: "none",
    stroke: "#676767",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.77,78s-8,2.5-13.5-.5a19.06,19.06,0,0,1-17,0c-6,3.5-12.59.61-13.5.5",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.27,116a101.26,101.26,0,0,0-5-19.3A97.53,97.53,0,0,0,73.77,78",
    fill: "none",
    stroke: "#676767",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.77,116a101.26,101.26,0,0,1,5-19.3,97.53,97.53,0,0,1,9.5-18.7",
    fill: "none",
    stroke: "#676767",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }));
}

var _default = ic_idea__or__innovation;
exports.default = _default;